/**
 * @author Karen Yunuen
 * @jobTitle Full Stack Developer - IBL
 * @email kpozos@ibl.mx
 * */

import {BuildingModalIcon, IconPersonPlusCard} from "../../../../../components/buttons/IconButtons";

export const REQUEST_ACCESS_TYPE = {
    FIND_EXISTING_PROFILE: {
        ID:"rbtn_qra_already_registered",
        INDEX: 1,
        TITLE: "i_am_already_registered",
        SUBTITLE: "find_my_existing_profile",
        ICON: BuildingModalIcon
    },
    I_AM_NEW_HERE: {
        ID:"rbtn_qra_new_here",
        INDEX: 2,
        TITLE: "i_am_new_here",
        SUBTITLE: "create_a_visitor_profile",
        ICON: IconPersonPlusCard
    }
}

export const REQUEST_ACCESS_STEP_MODEL = {
    FIND_MYSELF: {
        TOTAL: 4,
        NAME: 'FIND_MYSELF'
    },
    FIND_MYSELF_CREATE_VISITOR: {
        TOTAL: 5,
        NAME: 'FIND_MYSELF_CREATE_VISITOR'
    },
    I_AM_NEW_HERE: {
        TOTAL: 4,
        NAME: 'I_AM_NEW_HERE'
    }
}

export const REQUEST_ACCESS_MODEL = {
    requestReason: "",
    requestedById: null,
    visitToId: null,
    privacyConsent: false,
    toRegister: function () {
        return {
            requestReason: this.requestReason || null,
            requestedById: this.requestedById || null,
            visitToId: this.visitToId || null,
            privacyConsentDate: this.privacyConsent ? new Date().getTime() : null
        }
    },
    isValid: function () {
        return this.requestReason !== ""
    }
}
